<template>
	<v-menu bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
		<template v-slot:activator="{ attrs, on }">
			<v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
				<v-icon>mdi-account</v-icon>
			</v-btn>
		</template>

		<v-list :tile="false" flat nav>
			<template v-for="(p, i) in profile">
				<v-divider v-if="p.divider" :key="`divider-${i}`" class="mb-2 mt-2" />
				<app-bar-item v-else-if="p.emit && checkActivePart(p.part)" :key="`item-${i}`">
					<v-list-item-title @click="$emit(p.emit)" v-text="p.title" style="line-height: 3.5;" />
				</app-bar-item>
				<app-bar-item v-else-if="checkActivePart(p.part)" :key="i" :to="p.to">
					<v-list-item-title v-if="checkActivePart(p.part)" v-text="p.title" style="line-height: 3.5;" />
				</app-bar-item>
			</template>
		</v-list>
	</v-menu>
</template>

<script>
	import { get } from 'vuex-pathify'
	export default {
		name: 'DefaultAccount',

		data: () => ({
		}),
		computed: {
			...get('siteConfig', [
				'isCloud'
			]),
			profile() {
				let items = [
					{
						title: 'پروفایل',
						emit: 'profile',
					},
					{
						title: 'تنظیمات',
						emit: 'settings',
					},
					{
						title: 'تنظیمات رابط API',
						emit: 'apiSettings',
					},
					{
						title: 'ارتباط با دیگر نرم افزارها',
						emit: 'thirdParty',
						part: 'thirdParty'
					},
					{ divider: true },
					{ title: 'خروج', to: '/logout' },
				]
				if (this.isCloud)
					items.splice(1, 0, {
						title: 'خرید پلن',
						to: '/admin/purchasedPlans'
					})
				return items
			}
		},
	}
</script>
